__turbopack_context__.v({
  "alertYellow": "Ecb53W_alertYellow",
  "appVideo": "Ecb53W_appVideo",
  "black": "Ecb53W_black",
  "black90": "Ecb53W_black90",
  "content": "Ecb53W_content",
  "cyan": "Ecb53W_cyan",
  "darkStone": "Ecb53W_darkStone",
  "frame": "Ecb53W_frame",
  "frameImage": "Ecb53W_frameImage",
  "fuschiaPunch": "Ecb53W_fuschiaPunch",
  "item": "Ecb53W_item",
  "limeSorbet": "Ecb53W_limeSorbet",
  "mobileFrameImage": "Ecb53W_mobileFrameImage",
  "notSupported": "Ecb53W_notSupported",
  "olive100": "Ecb53W_olive100",
  "olive20": "Ecb53W_olive20",
  "paddingBottom0": "Ecb53W_paddingBottom0",
  "paddingBottom112": "Ecb53W_paddingBottom112",
  "paddingBottom128": "Ecb53W_paddingBottom128",
  "paddingBottom16": "Ecb53W_paddingBottom16",
  "paddingBottom32": "Ecb53W_paddingBottom32",
  "paddingBottom48": "Ecb53W_paddingBottom48",
  "paddingBottom64": "Ecb53W_paddingBottom64",
  "paddingBottom80": "Ecb53W_paddingBottom80",
  "paddingBottom96": "Ecb53W_paddingBottom96",
  "paddingTop0": "Ecb53W_paddingTop0",
  "paddingTop112": "Ecb53W_paddingTop112",
  "paddingTop128": "Ecb53W_paddingTop128",
  "paddingTop16": "Ecb53W_paddingTop16",
  "paddingTop32": "Ecb53W_paddingTop32",
  "paddingTop48": "Ecb53W_paddingTop48",
  "paddingTop64": "Ecb53W_paddingTop64",
  "paddingTop80": "Ecb53W_paddingTop80",
  "paddingTop96": "Ecb53W_paddingTop96",
  "softBlack": "Ecb53W_softBlack",
  "teal100": "Ecb53W_teal100",
  "teal20": "Ecb53W_teal20",
  "video": "Ecb53W_video",
  "warmStone": "Ecb53W_warmStone",
  "white": "Ecb53W_white",
});
